import { Default } from "../../components/Default/Default";
import { OportunidadesSortimentoTab } from "./components/OportunidadesSortimento/OportunidadesSortimento";
import { SYSTEM_COLORS } from "../../components/system.colors";

// página "Oportunidades de Sortimento"
export function OportunidadesSortimentoScreen() {
  return (
    <Default fullPage>
      <div style={{
        padding: "16px 28px", backgroundColor: SYSTEM_COLORS.WHITE.ALABASTER,
        display: "flex", flexDirection: "column", flex: 1, minHeight: 0,
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
        boxSizing: "border-box", width: "calc(100% - 72px)", overflowY: "auto", overflowX: "hidden",
        marginLeft: 72,
      }}>
        {/* título — mesmo estilo da tela de Qualificação de MIX */}
        <hgroup style={{ marginBottom: 14, flexShrink: 0 }}>
          <h1 style={{ fontSize: "22px", fontWeight: "700", color: "#1a1a1a", margin: 0, letterSpacing: "-0.3px" }}>
            Oportunidades de Sortimento
          </h1>
          <p style={{ fontSize: "13px", color: "#999", margin: "3px 0 0" }}>
            Produtos bem rankeados em Porto Alegre mas com performance muito abaixo na CenterShop
          </p>
        </hgroup>

        <OportunidadesSortimentoTab />
      </div>
    </Default>
  );
}
